export default {
  agentContact: "agentContact",
  error: "error",
  loading: "loading",
  success: "success"
};
